var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsWorkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:work-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 36.75C6.0375 36.75 5.21383 36.4076 4.529 35.7228C3.84417 35.0379 3.50117 34.2137 3.5 33.25V14C3.5 13.0375 3.843 12.2138 4.529 11.529C5.215 10.8442 6.03867 10.5012 7 10.5H14V7C14 6.0375 14.343 5.21383 15.029 4.529C15.715 3.84417 16.5387 3.50117 17.5 3.5H24.5C25.4625 3.5 26.2868 3.843 26.9727 4.529C27.6588 5.215 28.0012 6.03867 28 7V10.5H35C35.9625 10.5 36.7868 10.843 37.4728 11.529C38.1587 12.215 38.5012 13.0387 38.5 14V33.25C38.5 34.2125 38.1576 35.0368 37.4728 35.7228C36.7879 36.4087 35.9637 36.7512 35 36.75H7ZM7 33.25H35V14H7V33.25ZM17.5 10.5H24.5V7H17.5V10.5Z",
    fill: "#FE6E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsWorkOutline);
export default __webpack_public_path__ + "static/media/material-symbols-work-outline.5369eaa19168f517a288d2f3ad265256.svg";
export { ForwardRef as ReactComponent };